import { render, staticRenderFns } from "./LevelFailView.vue?vue&type=template&id=1b4d63d8&scoped=true&"
import script from "./LevelFailView.vue?vue&type=script&lang=js&"
export * from "./LevelFailView.vue?vue&type=script&lang=js&"
import style0 from "./LevelFailView.vue?vue&type=style&index=0&id=1b4d63d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d63d8",
  null
  
)

/* custom blocks */
import block0 from "./LevelFailView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports